module.exports = __webpack_public_path__ + "img/red-desert-decal-10.8a2c6b22.png";